import fetcher from 'api/fetcher';
import { downloadCSV } from 'utils/clickme';
import { VIEW_DATE_WITHOUT_DAY_YEAR_FIRST_FORMAT } from 'utils/constants/date';
import { formatDate } from 'utils/date';

import urlParser from 'bloko/common/urlParser';

import { setCSVLoadActsSummary } from 'store/models/actsSummary';
import { AppThunkAction } from 'store/utils';

export const fetchActsSummaryReportCSV = (abortSignal?: AbortSignal): AppThunkAction => {
    return (dispatch, getState) => {
        const state = getState();
        const { currentDate } = state.actsSummary;
        dispatch(setCSVLoadActsSummary(true));
        const queryStr = urlParser.stringify({
            date: formatDate(currentDate, VIEW_DATE_WITHOUT_DAY_YEAR_FIRST_FORMAT),
        });

        return fetcher
            .get<unknown, string>(`/api/v1/reports/acts/monthly/csv?${queryStr}`, {
                signal: abortSignal,
                timeout: 300000,
            })
            .then((csv) => {
                const fileName = `monthly_act_${String(currentDate)}.csv`;
                downloadCSV(fileName, csv);
                dispatch(setCSVLoadActsSummary(false));
            });
    };
};
